import { Badge } from "@/components/ui/badge";

const statusColors: Record<string, string> = {
  draft: "bg-muted text-muted-foreground border-border",
  submitted: "bg-accent text-accent-foreground border-accent",
  sent: "bg-accent text-accent-foreground border-accent",
  pending: "bg-accent text-accent-foreground border-accent",
  approved: "bg-primary/15 text-primary border-primary/30",
  rejected: "bg-destructive/15 text-destructive border-destructive/30",
  closed: "bg-secondary text-secondary-foreground border-secondary",
  cancelled: "bg-muted text-muted-foreground border-border",
  posted: "bg-primary/15 text-primary border-primary/30",
  reversed: "bg-destructive/15 text-destructive border-destructive/30",
  void: "bg-destructive/15 text-destructive border-destructive/30",
  voided: "bg-destructive/15 text-destructive border-destructive/30",
  partially_paid: "bg-amber-100 text-amber-700 border-amber-300 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700",
  overdue: "bg-destructive/15 text-destructive border-destructive/30",
  active: "bg-primary/15 text-primary border-primary/30",
  on_hold: "bg-accent text-accent-foreground border-accent",
  completed: "bg-secondary text-secondary-foreground border-secondary",
  archived: "bg-muted text-muted-foreground border-border",
  scheduled: "bg-primary/15 text-primary border-primary/30",
  paid: "bg-primary/15 text-primary border-primary/30",
};

const formatLabel = (s: string) =>
  s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const StatusBadge = ({ status }: { status: string }) => (
  <Badge variant="outline" className={statusColors[status] ?? ""}>
    {formatLabel(status)}
  </Badge>
);
